import './style/App.css';

import { useEffect } from "react";
import { Link } from "react-router-dom";

function NotFound() {
    useEffect(() => {
        document.title = "Not Found";
    }, []);

    return (
        <div className="article-content">
            <h1 className="article-content">Nothing here</h1>
            <p className="article-content">This page doesn't exist, or it has wandered off. <Link className="inline-ref" to="/">Back to all posts</Link>.</p>
        </div>
    );
}

export default NotFound;
